import { Trash2 } from 'lucide-react'
import type { Action } from '@/shared/types/admin'
import type { UseFormRegister, UseFormSetValue } from 'react-hook-form'

interface ProgrammeActionRowProps {
  index: number
  register: UseFormRegister<any>
  setValue: UseFormSetValue<any>
  actionsDisponibles: Action[]
  onRemove: () => void
}

export function ProgrammeActionRow({ index, register, setValue, actionsDisponibles, onRemove }: ProgrammeActionRowProps) {
  const inputClass =
    'h-10 w-full rounded-lg border border-neutral-300 bg-neutral-50 px-3 text-sm transition-colors hover:border-neutral-400 focus:border-primary focus:bg-white focus:outline-none focus:ring-2 focus:ring-primary/25'

  return (
    <div className="flex items-center gap-3 rounded-lg border border-neutral-200 bg-neutral-50/50 p-3">
      <div className="flex-1">
        <select
          {...register(`actions.${index}.actionId`, { valueAsNumber: true })}
          className={inputClass}
        >
          <option value={0}>-- Sélectionner une action --</option>
          {[...actionsDisponibles].sort((a, b) => a.libelle.localeCompare(b.libelle)).map((action) => (
            <option key={action.id} value={action.id}>
              {action.libelle}
            </option>
          ))}
        </select>
      </div>
      <div className="w-24">
        <input
          type="number"
          {...register(`actions.${index}.jourDeclenchement`, { valueAsNumber: true })}
          placeholder="Jour"
          className={inputClass}
        />
      </div>
      <button
        type="button"
        onClick={onRemove}
        className="shrink-0 rounded-md p-1.5 text-neutral-400 transition-colors hover:bg-red-50 hover:text-red-600"
      >
        <Trash2 className="h-4 w-4" />
      </button>
    </div>
  )
}
